export const MLP_TYPES = {
  landing: 'l',
  organizer: 'organizer',
};

export const MLP_NAVBAR_LOGO =
  'https://images.ctfassets.net/cocwkk0wzcrd/uOBOzGNgRWKUUxl6jE8od/e102d5532dd80671c362aea339d99676/Organizer.svg';
